import React from "react";
import { Grid, Stack, Typography } from "@mui/material";
import LabeledText from "../../../Widgets/LabeledText";
import {
  TelehealthPrerequisitesFormValues,
  DROPDOWN_FIELDS,
  MINUTE_PAIR_FIELDS,
  TEXT_AREA_FIELDS,
  YES_NO_SOMETIMES_OPTIONS,
} from "./interface";

interface ViewFieldsProps {
  formValues: TelehealthPrerequisitesFormValues;
}

const formatYesNoSometimes = (value: string): string =>
  YES_NO_SOMETIMES_OPTIONS.find((o) => o.value === value)?.label ?? (value || "-");

export const ViewFields: React.FC<ViewFieldsProps> = ({ formValues }) => {
  return (
    <Grid container sx={{ rowGap: "24px" }}>
      {DROPDOWN_FIELDS.map(({ label, key }) => (
        <LabeledText key={key} label={label} value={formatYesNoSometimes(formValues[key])} />
      ))}

      {MINUTE_PAIR_FIELDS.map(({ label, minutesKey, totalKey, naKey }) => {
        const minutes = formValues[minutesKey];
        const total = formValues[totalKey];
        const display = formValues[naKey]
          ? "Not Applicable"
          : minutes || total
          ? `${minutes || "0"} of ${total || "0"}`
          : "-";
        return (
          <Grid item xs={12} key={minutesKey}>
            <Stack gap={1}>
              <Typography variant="inputLabel" sx={{ color: "#798397" }}>
                {label}
              </Typography>
              <Typography variant="body2">{display}</Typography>
            </Stack>
          </Grid>
        );
      })}

      {TEXT_AREA_FIELDS.map(({ label, key }) => (
        <LabeledText key={key} label={label} value={formValues[key]} />
      ))}
    </Grid>
  );
};

export default ViewFields;
